module.exports = __webpack_public_path__ + "img/首页banner.2911c421.png";